var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (machineToMachineApp) {pug_html = pug_html + "\u003Cdiv class=\"machine-to-machine-page\"\u003E\u003Cdiv id=\"js-machine-to-machine-app\"\u003E" + (null == (pug_interp = machineToMachineApp) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"machineToMachineApp" in locals_for_with?locals_for_with.machineToMachineApp:typeof machineToMachineApp!=="undefined"?machineToMachineApp:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/machine-to-machine/view/index.pug
// module id = 1236
// module chunks = 0